<template>
  <div class="ui-content dashboard res-analisis-page-studentwise">
    <v-card class="mx-auto normal-card autohg">
      <div class="user-data StudentwiseHealth">
        <v-row>
          <v-col cols="12" sm="12">
            <div class="show-drop-down">
              <div class="label-data">Select Center(s)</div>
              <div class="field-data">
                <multi-select
                  allText="All Centers"
                  :items="centers"
                  label="select center"
                  :onChange="onCenterchange"
                  widthcss="fix-width-200"
                ></multi-select>
              </div>
            </div>
            <div class="show-drop-down">
              <div class="label-data">Select Batch(es)</div>
              <div class="field-data">
                <multi-select
                  allText="All Batches"
                  :items="batches"
                  label="select batch"
                  :onChange="onBatchSelect"
                  widthcss="fix-width-200"
                ></multi-select>
              </div>
            </div>
            <div class="download-section" v-if="user.role_id !== roleIds.TR">
              <v-btn
                color="transparent"
                class="ma-2 black--text download-btn"
                depressed
                @click="downloadStudentData()"
              >
                <v-img src="../../../assets/img/download.svg" width="26" height="26"></v-img>
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </div>
      <div
        class="health-card-section student-health-report"
        v-if="headers.length > 1"
      >
        <v-data-table
          :headers="headers"
          fixed-header
          :mobile-breakpoint="0"
          :items="studentSubjectHealthList"
          class="elevation-2 cust-table"
          must-sort
          :options.sync="sort"
          :page.sync="page"
          :items-per-page.sync="itemsPerPage"
          hide-default-footer
          @update:page="updateSort"
        >
          <template v-slot:body="{ items }">
            <tbody>
              <tr v-for="(item, idx) in items" :key="item.id">
                <td>{{ item.roll_number || item.id }}</td>
                <td class="header-width center-name-th" :key="item.studentName">
                  {{ item.studentName }}
                </td>
                <td
                  class="text-center progress-th header-width"
                  v-for="subject in item.subjects"
                  :key="subject.name"
                >
                  <div class="subject-details" v-if="subject.hasSubject">
                    <div class="subject-progress">
                      <v-progress-linear
                        :value="item[subject.value]"
                        :height="25"
                        :color="getColor(item[subject.value])"
                        >{{ item[subject.value] + "%" }}</v-progress-linear
                      >
                    </div>
                    <div
                      class="add-subject"
                      @click="openChart(subject, item.studentName, item.id)"
                    >
                      <v-btn class="add-btn" fab>
                        <v-icon dark>mdi-plus</v-icon>
                      </v-btn>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </template>
        </v-data-table>
      </div>
    </v-card>
    <div class="footer-btn">
      <div></div>
      <div class="pull-right">
        <Pagination
          :currentPage="page"
          :totalPage="totalPages"
          :onPageChange="onPageChange"
        />
      </div>
    </div>
    <AlertBox
      :width="modalwidth"
      :onClose="onClose"
      :component="cComponent"
      :status="status"
      :data="alertBoxData"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
const user = JSON.parse(sessionStorage.getItem("user"));
import constants from "@/utils/constants.js";

export default {
  name: "StudentwiseHealth",
  props: ["searchQuery", "selectedTab"],
  data() {
    return {
      headers: [],
      currentPage: 1,

      selectedCenterId: [],
      selectedBatch: [],
      testData: [],
      studentSubjectHealthList: [],
      currentTab: "Health Analysis",
      subjectList: [],
      modalwidth: null,
      cComponent: "",
      alertBoxData: {},
      persistent: false,
      status: false,
      centers: [],
      batches: [],
      gotAllTests: false,
      page: 1,
      itemsPerPage: 10,
      totalPages: 1,
      sortBy: "studentName",
      sortDesc: false,
      isLoadingFirstTime: true,
      sort: {},
      sort_subject_id: 0,
      isShowBatch: true,
      isShowCenters: true,
      pageSize: 10,
    };
  },
  mounted() {
    this.checkSessionData();
  },
  methods: {
    ...mapActions({
      getCenters: "centerAndBatchStore/getCenters",
      getCentersByUser: "centerAndBatchStore/getCentersByUser",
      getBatches: "centerAndBatchStore/getBatches",
      getSubjectHealthStudentWise: "resultStore/getSubjectHealthStudentWise",
      getBatchStudentsSubjectTree:
        "centerAndBatchStore/getBatchStudentsSubjectTree",
    }),
    updateRouteDetails(details) {
      let routeName = this.$route.name;
      let crd = this.getCurrentRouteDetails(routeName);
      if (crd.tabDetails[crd.selectedTab]) {
        switch (details.type) {
          case "centerIds":
            crd.tabDetails[crd.selectedTab].centerIds = details.data.centerIds;
            break;
          case "batchIds":
            crd.tabDetails[crd.selectedTab].batchIds = details.data.batchIds;
            break;
          case "sortBy":
            crd.tabDetails[crd.selectedTab].sortBy = details.data.sortBy;
            break;
          case "sortDesc":
            crd.tabDetails[crd.selectedTab].sortDesc = details.data.sortDesc;
            break;
          default:
            break;
        }
      }
      this.setRouteDetails(crd);
    },
    downloadStudentData() {
      if (this.studentSubjectHealthList.length) {
        let token = sessionStorage.getItem("auth_token");
        let reqData = {
          sort_subject_id: this.sort_subject_id || 0,
          sort_type: this.sortDesc ? "DESC" : "ASC",
        };
        if (this.searchQuery) {
          reqData.searchQuery = this.searchQuery;
        }
        if (
          this.selectedCenterId &&
          this.selectedCenterId.length > 0 &&
          this.classes.length != this.selectedCenterId.length
        ) {
          reqData.center_ids = this.selectedCenterId;
        }
        if (
          this.selectedBatch &&
          this.selectedBatch.length > 0 &&
          this.batches.length != this.selectedBatch.length
        ) {
          reqData.batch_ids = this.selectedBatch;
        }
        if (
          this.selectedCenterId &&
          this.selectedCenterId.length > 0 &&
          this.centers.length != this.selectedCenterId.length
        ) {
          reqData.center_ids = this.selectedCenterId;
        }
        let domainUrl = process.env.VUE_APP_API_URL;
        let params = this.serializeObject(reqData);
        let url =
          domainUrl +
          `/users/download-batch-students-subject-tree?token=${token}${params}`;
        //   alert(url);
        window.open(url, "_blank");
      } else {
        this.$toasted.error(`No data to export`, { icon: "info" });
      }
    },
    defaultData() {
      let routeName = this.$route.name;
      let crd = this.getCurrentRouteDetails(routeName);
      if (
        crd &&
        crd.hasOwnProperty("tabDetails") &&
        crd.tabDetails.hasOwnProperty("Health Analysis")
      ) {
        this.sortBy = crd.tabDetails[crd.selectedTab].sortBy;
        this.sortDesc = crd.tabDetails[crd.selectedTab].sortDesc;
        this.currentPage = crd.tabDetails[crd.selectedTab].page;
        this.page = crd.tabDetails[crd.selectedTab].page;
        this.selectedCenterId = crd.tabDetails[crd.selectedTab].centerIds; // load center ids from session
        this.selectedBatch = crd.tabDetails[crd.selectedTab].batchIds; // load batches in session
      }
      this.requestGetCenters();
      this.getBatchStudentsSubject();
    },
    checkSessionData() {
      let rp = this.$route; // route params
      let crd = this.getCurrentRouteDetails(rp.name);

      if (rp.params.resetPage || !crd.routeName) {
        let tabDetail = {
          default: {
            page: 1,
            centerIds: [],
            batchIds: [],
            sortBy: "studentName",
            sortDesc: false,
          },
        };
        let routeDetails = {
          routeName: rp.name,
          selectedTab: "default",
          tabDetails: tabDetail,
        };
        this.setRouteDetails(routeDetails);
      }
      this.defaultData();
    },
    updateSort(sort) {
      this.$nextTick(() => {
        this.page = this.currentPage;
      });
    },
    getColor(percentage) {
      let color = "";
      if (percentage > 65) {
        color = this.STUDENT_HEALTH_PERCENTAGE_COLOR.GREEN;
      } else if (percentage > 19) {
        color = this.STUDENT_HEALTH_PERCENTAGE_COLOR.ORANGE;
      } else {
        color = this.STUDENT_HEALTH_PERCENTAGE_COLOR.RED;
      }
      return color;
    },
    openChart(subject, studentName, studentId) {
      this.alertBoxData = {
        subject,
        studentName,
        showChapterInfo: true,
        studentId,
      };
      this.cComponent = "components/student/health/StudentChapterTopicChart";
      this.modalwidth = "800px";
      this.status = true;
      this.$forceUpdate();
    },
    onClose(data) {
      this.status = data.status;
    },
    resetPage() {
      this.page = 1;
      this.currentPage = 1;
      this.updateSort({});
      this.updateCurrentPageInSession(1);
      this.totalPages = 1;
      this.studentSubjectHealthList = [];
    },
    onBatchSelect(selectedBatch) {
      if (this.isLoadingFirstTime) this.resetPage();
      this.selectedBatch = selectedBatch;
    },
    onCenterSelect(centerIds) {
      if (this.isLoadingFirstTime) {
        this.resetPage();
      }
      if (centerIds && centerIds.length) {
        this.updateRouteDetails({
          type: "centerIds",
          data: { centerIds: this.selectedCenterId },
        });
        this.$root.showLoader = true;
        this.getBatches({ center_id: centerIds })
          .then((response) => {
            if (response && response.list && response.list.length) {
              if (this.selectedBatch) {
                let arr = [];
                this.selectedBatch.map((xx, i) => {
                  let isExist = false;
                  response.list.map((x) => {
                    if (!isExist) {
                      isExist = xx === x.id;
                    }
                  });
                  if (!isExist) {
                    arr.push(xx);
                  }
                });
                if (arr && arr.length) {
                  arr.map((xx) => {
                    this.selectedBatch.splice(
                      this.selectedBatch.indexOf(xx),
                      1
                    );
                  });
                }
              }
              let batchIds = [];
              this.batches = response.list.map((x) => {
                batchIds.push(x.id);
                let c = {};
                c.text = x.name;
                c.value = x.id;
                c.checked =
                  this.selectedBatch && this.selectedBatch.indexOf(x.id) !== -1;
                return c;
              });
              // this.getTestList();
              // if (!this.gotAllTests) {
              //     this.gotAllTests = true;
              //     this.batches = this.batches.map(batch => {
              //         batch.checked = true;
              //         return batch;
              //     });
              //     this.selectedBatch = batchIds;
              //     // this.getTestList(batchIds);
              // }
            } else {
              this.batches = [];
            }
            this.$root.showLoader = false;
          })
          .catch((err) => {
            this.$root.showLoader = false;
          });
      } else {
        this.batches = [];
      }
    },
    getCentersFunction() {
      if (user && user.role_id === constants.ROLES_ID.CO) {
        return "getCentersByUser";
      }
      return "getCenters";
    },
    requestGetCenters() {
      this.$root.showLoader = true;
      this[this.getCentersFunction()]()
        .then((response) => {
          this.$root.showLoader = false;
          let centerIds = [];
          this.centers = response.map((x) => {
            centerIds.push(x.id);
            let c = {};
            c.text = x.name;
            c.value = x.id;
            c.checked = this.selectedCenterId.includes(x.id);
            return c;
          });
          // this.onCenterSelect(centerIds);
        })
        .catch((err) => {
          this.$root.showLoader = false;
        });
    },
    onPageChange(e) {
      this.page = e;
      this.currentPage = e;
      this.getBatchStudentsSubject();
    },
    onCenterchange(centerIds) {
      this.selectedCenterId = centerIds;
      // this.selectedBatch = null;
    },
    generateHeaders(subjects) {
      this.headers = [
        ...[
          {
            text: "Student Id / \nRoll No.",
            value: "roll_number",
            align: "left",
            hideSort: true
          },
          {
            text: "Name",
            value: "studentName",
            align: "left",
            class: "health-header",
          },
        ],
        ...subjects,
      ];
    },

    async getAllSubjects(studentInfo) {
      let allSubjects = {};
      this.totalPages = studentInfo.pagination.pageCount;
      studentInfo.list.map((student) => {
        let subjects = student.subjects;
        subjects.map((subjectDetails) => {
          allSubjects[subjectDetails.title] = {
            text: subjectDetails.title,
            subjectId: subjectDetails.id,
            value: subjectDetails.title.toLowerCase(),
            class: "health-header",
          };
        });
      });
      return allSubjects;
    },
    async processStudentData(studentInfo) {
      this.studentSubjectHealthList = [];
      let allSubjects = await this.getAllSubjects(studentInfo);
      this.generateHeaders(Object.values(allSubjects));
      let subjectNames = Object.keys(allSubjects);
      // return;

      let studentList = studentInfo.list;
      let list = studentList.map((stud) => {
        this.$root.showLoader = true;
        // loop on students
        let obj = {};
        obj.studentName = stud.name;
        obj.id = stud.id;
        obj.roll_number = stud.roll_number;
        obj.subjectData = [];
        let subjectInfo = stud.subjects;
        subjectNames.forEach((subject) => {
          this.$root.showLoader = true;
          // loop on each subject and check if it exists for current student
          let subjectObj = {};

          let sub = subjectInfo.find((s) => s.title == subject);
          if (sub) {
            subjectObj.hasSubject = true;
            subjectObj.name = subject;
            subjectObj.id = sub.id;
            obj[subject.toLowerCase()] = sub.health;
            subjectObj.value = subject.toLowerCase();
            // subjectObj[subject.toLowerCase()] = sub.health;
            subjectObj.healthPercentage = sub.health;
          } else {
            subjectObj.hasSubject = false;
            subjectObj.value = subject.toLowerCase();
            obj[subject.toLowerCase()] = -1;
          }
          obj.subjectData.push(subjectObj);
        });

        return {
          studentName: obj.studentName,
          id: obj.id,
          ...obj,
          subjects: obj.subjectData,
        };
      });
      this.$root.showLoader = false;
      this.studentSubjectHealthList = list;
    },
    getBatchStudentsSubject() {
      let postData = {
        children: 1,
        pagination: {
          pageSize: this.pageSize,
          page: this.page,
        },
        searchQuery: this.searchQuery,
        sort_subject_id: this.sort_subject_id || 0,
        sort_type: this.sortDesc ? "DESC" : "ASC",
      };

      postData.batch_ids = [];
      postData.center_ids = [];
      if (this.selectedBatch.length) postData.batch_ids = this.selectedBatch;
      if (this.selectedCenterId.length)
        postData.center_ids = this.selectedCenterId;

      this.$root.showLoader = true;

      this.getBatchStudentsSubjectTree(postData)
        .then((response) => {
          if (
            response.list.length == 0 &&
            this.currentPage != 1 &&
            !this.$route.query.resetPage
          ) {
            this.onPageChange(1);
            return;
          }

          this.isLoadingFirstTime = false;
          this.processStudentData(response);
          this.$root.showLoader = false;
        })
        .catch((err) => {
          this.$root.showLoader = false;
        });
    },
  },
  watch: {
    searchQuery() {
      if (this.selectedTab === this.currentTab)
        setTimeout(() => {
          this.getBatchStudentsSubject();
        }, 500);
    },
    selectedCenterId(val) {
      if (val) {
        this.onCenterSelect(val);
        if (!this.isLoadingFirstTime) {
          this.getBatchStudentsSubject();
        }
      }
    },
    selectedBatch(val) {
      this.updateRouteDetails({
        type: "batchIds",
        data: { batchIds: this.selectedBatch },
      });
      if (!this.isLoadingFirstTime) {
        this.getBatchStudentsSubject();
      }
    },

    sort(val) {
      const { sortBy, sortDesc, page, itemsPerPage } = val;
      if (sortBy[0] === "studentName") {
        this.sort_subject_id = 0;
        this.sortDesc = sortDesc[0];
      } else {
        this.headers.map((h) => {
          if (h.value === sortBy[0]) {
            (this.sort_subject_id = h.subjectId), (this.sortDesc = sortDesc[0]);
          }
        });
      }

      this.updateRouteDetails({
        type: "sortDesc",
        data: { sortDesc: this.sortDesc },
      });
      this.updateRouteDetails({
        type: "sortBy",
        data: { sortBy: this.sortBy },
      });
      if (sortBy.length > 0 && sortDesc.length > 0) {
        if (!this.isLoadingFirstTime) {
          this.getBatchStudentsSubject();
        }
      }
    },
  },
  computed: {
    ...mapState("userStore", ["user"]),
  }
};
</script>
<style scoped>
.header-width {
  width: 600px !important;
}
</style>
